import React, { useEffect } from "react"
import { useSolutionLevelScheduledReportExportContext } from "contexts/SolutionLevelScheduledReportExportContext"
import {
  DAILY,
  WEEKLY,
  MONTHLY,
} from "utils/recurrenceDetailsHelpers"
import {
  DAYS, MONTHS, WEEKS,
} from "utils/dateHelpers"
import queryParameter from "utils/queryParameter"
import DetailFields from "shared/ScheduledReportExport/DetailFields"

const RANGE_UNIT_BY_FREQUENCY = {}
RANGE_UNIT_BY_FREQUENCY[DAILY] = DAYS
RANGE_UNIT_BY_FREQUENCY[WEEKLY] = WEEKS
RANGE_UNIT_BY_FREQUENCY[MONTHLY] = MONTHS

const NAME_PARAM = "name"
const REPORT_FREQUENCY_PARAM = "frequency"

const unitByFrequency = (frequency) => RANGE_UNIT_BY_FREQUENCY[frequency]

const NewSolutionLevelScheduledReportExportDetailFields = () => {
  const {
    frequency,
    recurrenceDayOfMonth,
    recurrenceDayOfWeek,
    setReportFrequency,
    setRecurrenceDayOfMonth,
    setRecurrenceDayOfWeek,
    setReportableFieldAnswerPreviousRangeUnit,
    setScheduledReportExportName,
    setStartDate,
    setSubmissionPreviousRangeUnit,
    scheduledReportExportName,
    startDate,
  } = useSolutionLevelScheduledReportExportContext()

  // When the component is registered, check the query params for name and frequency
  useEffect(() => {
    if (queryParameter(NAME_PARAM)) {
      setScheduledReportExportName(queryParameter(NAME_PARAM))
    }

    if (queryParameter(REPORT_FREQUENCY_PARAM)) {
      setReportFrequency(queryParameter(REPORT_FREQUENCY_PARAM))
      setSubmissionPreviousRangeUnit(unitByFrequency(queryParameter(REPORT_FREQUENCY_PARAM)))
      setReportableFieldAnswerPreviousRangeUnit(unitByFrequency(queryParameter(REPORT_FREQUENCY_PARAM)))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <DetailFields
      frequency={frequency}
      recurrenceDayOfMonth={recurrenceDayOfMonth}
      recurrenceDayOfWeek={recurrenceDayOfWeek}
      setRecurrenceDayOfMonth={setRecurrenceDayOfMonth}
      setRecurrenceDayOfWeek={setRecurrenceDayOfWeek}
      setScheduledReportExportName={setScheduledReportExportName}
      setStartDate={setStartDate}
      scheduledReportExportName={scheduledReportExportName}
      startDate={startDate}
    />
  )
}

export default NewSolutionLevelScheduledReportExportDetailFields
